import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const REQUEST_REFUND = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'requestRefund',
    operationName: 'requestRefund',
    args: [
      { name: 'opportunity_id', type: 'String', required: true },
      { name: 'sr_cancellation_reason', type: 'String', required: true },
      { name: 'sr_status', type: 'String', required: true },
      { name: 'customer_id', type: 'String', required: true },
      { name: 'bank_name', type: 'String', required: true },
      { name: 'bank_account_number', type: 'String', required: true },
      { name: 'bank_account_name', type: 'String', required: true },
      { name: 'name', type: 'String', required: true },
      { name: 'mobile_country_code', type: 'String', required: true },
      { name: 'mobile', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'opportunity_id', value: 'opportunity_id' },
      { name: 'sr_cancellation_reason', value: 'sr_cancellation_reason' },
      { name: 'sr_status', value: 'sr_status' },
      { name: 'customer_id', value: 'customer_id' },
      { name: 'bank_name', value: 'bank_name' },
      { name: 'bank_account_number', value: 'bank_account_number' },
      { name: 'bank_account_name', value: 'bank_account_name' },
      { name: 'name', value: 'name' },
      { name: 'mobile_country_code', value: 'mobile_country_code' },
      { name: 'mobile', value: 'mobile' },
    ],
    fields: '{...RequestRefundResponseFields}',
    fragments: [Fragments.requestRefundResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
